{
  "folders": {
    "actions": {
      "rename": "Rename",
      "move_to": "Move to",
      "create_workspace": "Create Workspace",
      "create_folder": "Create Folder",
      "delete": "Delete"
    },
    "forms": {
      "folder_name": "Folder Name",
      "enter_folder_name": "Enter a folder name",
      "my_folders": "My Folders",
      "move_here": "Move Here",
      "choose_folder": "Choose a folder"
    },
    "confirmations": {
      "delete_folder_title": "Delete folder?",
      "delete_folder_content": "Are you sure you want to delete this folder? You can't undo this action.",
      "move_workspace": "Move Workspace"
    },
    "errors": {
      "unable_to_delete": "Unable to Delete"
    }
  },
  "members": {
    "team": "Team",
    "add_member": "Add Member",
    "add_team_members": "Add Team Members",
    "team_member": "Team Member",
    "who_add_placeholder": "Who do you want to add to this workspace",
    "validation": {
      "select_team_member": "Please select at least one team member"
    },
    "confirmations": {
      "remove_member_title": "Are you sure you want to remove this member?",
      "remove_member_content": "This person will no longer have access to the workspace."
    },
    "aria_labels": {
      "remove_member": "remove member {{email}}"
    }
  },
  "forms": {
    "title": "Title",
    "folder": "Folder",
    "icon": "Icon",
    "color": "Color",
    "firm_wide_access": "Allow Firm Wide Access",
    "read_only": "Read Only",
    "validation": {
      "title_required": "Please enter project title"
    },
    "placeholders": {
      "app_description": "What is your app about?",
      "workspace_description": "How will you collaborate in this Workspace"
    },
    "aria_labels": {
      "project_icon": "project icon {{index}}",
      "select_color": "select {{description}}"
    }
  },
  "actions": {
    "create_app": "Create App",
    "create_workspace": "Create Workspace",
    "update_app": "Update App",
    "update_workspace": "Update Workspace",
    "clone_app": "Clone App",
    "clone_workspace": "Clone Workspace"
  },
  "status": {
    "loading_workspaces": "Loading workspaces",
    "search_no_results": "Cannot find workspace(s) with the title \"{{term}}\"",
    "no_workspaces": "There's no workspace and folder for you, create one now"
  },
  "table": {
    "headers": {
      "name": "Name",
      "owner": "Owner",
      "created_at": "Created At",
      "project": "Project",
      "team_members": "Team members"
    }
  },
  "tooltips": {
    "firm_wide_workspace": "Firm Wide Workspace"
  },
  "app": {
    "create_view_label": "Company View",
    "read_only": "Read-only",
    "no_access_message": "You don't have access to this project. Please ask the person who shared the link with you to add you as a team member.",
    "search_no_results": "Cannot find app(s) with the title \"{{term}}\"",
    "no_apps_message": "There's no app for you, create one now",
    "view_table": "Table",
    "view_grid": "Grid",
    "get_started_message": "To get started, add your first list from the + button above on the left.",
    "unknown_tab_type": "Unknown tab type",
    "table": {
      "app_header": "App",
      "workspace_header": "Workspace",
      "team_members_header": "Team members"
    },
    "team_share": "Team/Share",
    "team": "Team"
  },
  "opportunities": {
    "form": {
      "header": "Opportunity",
      "company_label": "Select Associated Company *",
      "company_placeholder": "Type to search company",
      "status_label": "Status",
      "description_label": "Description",
      "description_placeholder": "Describe your opportunity in one sentence",
      "tags_label": "Tags",
      "proposed_fee_label": "Proposed Fee",
      "date_label": "Opportunity Date",
      "date_placeholder": "date",
      "internal_owner_label": "Internal Owner",
      "internal_owner_placeholder": "Who will be responsible for this opportunity?",
      "team_involved_label": "Team Involved",
      "team_involved_placeholder": "Team involved in this opportunity?",
      "referral_source_label": "Referral Source",
      "referral_source_placeholder": "Who referred this opportunity?"
    },
    "workspace": {
      "link_button": "Link Workspace",
      "link_modal_label": "Workspaces",
      "link_validation": "Please select a workspace",
      "unlink_title": "unlink opportunity from workspace",
      "unlink_confirmation": "Click confirm to unlink the opportunity from workspace",
      "unlink_confirm_title": "Are you sure you want to unlink this opportunity?",
      "actions": {
        "update": "Update",
        "unlink": "Unlink"
      },
      "custom_fields": {
        "section_header": "Workspace Columns"
      }
    },
    "opportunity_actions": {
      "add_opportunity": "Add Opportunity",
      "add_column": "Add Column"
    },
    "no_opportunities": {
      "title": "No Opportunities Yet",
      "description": "You haven't added any opportunities.",
      "call_to_action": "Start by creating a new opportunity to your workspace."
    },
    "filters": {
      "search_placeholder": "Search",
      "assign_to": "Assign to",
      "referral_source": "Referral Source",
      "date": "Date"
    },
    "errors": {
      "generic_error": "Something went wrong, please contact support"
    }
  },
  "more_actions": {
    "manage_columns": "Manage Columns"
  },
  "project_actions": {
    "clone_app": "Clone App",
    "clone_project": "Clone Project",
    "clone_workspace": "Clone Workspace",
    "edit_app": "Edit App",
    "edit_workspace": "Edit Workspace",
    "archive_app": "Archive App",
    "archive_workspace": "Archive Workspace",
    "copy_list_id": "Copy List ID",
    "link_to_teams": "Link to Microsoft Teams",
    "rollup_fields": "Rollup Fields",
    "actions": "Actions"
  },
  "task_forms": {
    "task_label": "Task",
    "due_date_label": "Due Date",
    "assign_to_label": "Assign To",
    "task_placeholder": "Describe the task",
    "task_button": "Task",
    "task_validation": "Please enter a task"
  },
  "table_headers": {
    "name_header": "Name",
    "owner_header": "Owner",
    "created_at_header": "Created At"
  },
  "modals": {
    "create_task": "Create Task",
    "update_task": "Update Task",
    "list_id_header": "List Id",
    "list_id_description": "Current list ID for easy use with APIs"
  },
  "confirmations": {
    "archive_app": "Click confirm to archive the app.",
    "archive_workspace": "Click confirm to archive the workspace.",
    "delete_note": "Are you sure you want to delete this note?",
    "delete_document": "Are you sure you want to delete this document?",
    "no_edit_access": "You don't have edit access for this workspace"
  },
  "labels": {
    "remove_workspace": "Remove workspace",
    "document": "Document",
    "note": "Note",
    "workspace_actions": "Workspace actions",
    "create_workspace_task": "create workspace task",
    "update_task": "update task",
    "create_note": "Create note",
    "edit_project_document": "edit project document",
    "add_document": "add document",
    "remove_project_document": "remove project document"
  },
  "teams": {
    "modal_header": "Link to Microsoft Teams",
    "modal_caption": "To give you and your team easy access to your NEXL projects, you can link your projects with Microsoft teams for easy access and increased collaboration. Follow the steps below to add your project to MS Teams.",
    "step_1_title": "Step 1",
    "step_1_description": "Copy the link below.",
    "step_2_title": "Step 2",
    "step_2_description": "Open Microsoft Teams and navigate to the channel to which you want to add the NEXL Project or create a new channel. Then click the \"+\" icon at the top of the MS Teams Channel page to add a new Tab.",
    "step_3_title": "Step 3",
    "step_3_description": "Use the search box at the top right to search for \"Website\". Then click on the \"Website\" icon as seen in the image below.",
    "step_4_title": "Step 4",
    "step_4_description": "Enter a name for the Tab and paste the NEXL Project URL into the URL field. Once done, click on \"Save\". Now you are able to access your NEXL Project right from within Microsoft Teams.",
    "got_it_button": "Got it!",
    "microsoft_teams_tab_url_label": "microsoft teams tab url"
  },
  "objectives": {
    "title": "Objectives",
    "add_objective": "Objective"
  },
  "notes": {
    "title": "Notes",
    "description": "Share comments and notes with your team."
  },
  "template": {
    "use_template": "Use Template",
    "cloning_status": "CLONING"
  },
  "overview": {
    "collaboration_title": "How we will collaborate",
    "tasks": {
      "title": "Tasks",
      "view_all": "View all",
      "view_all_aria": "view all the tasks in this workspace"
    }
  },
  "tabs": {
    "loading": "Loading project tabs..."
  }
}
